import { textFilter } from "react-bootstrap-table2-filter";
import {
  DeepMergeObject,
  DotStringToObject,
  GetHeaderStyle,
  GetNormalStyle,
  Post,
} from "../core/Helper";

export class GoodsService {
  static async GetList(params) {
    let result = await Post("api/goods/select", params);
    return result ?? null;
  }

  static async GetData(params) {
    let result = await Post("api/goods/getData", params);
    return result ?? null;
  }

  static async Delete(params) {
    let result = await Post("api/goods/delete", params);
    return result ?? null;
  }

  static async SelectedList(params) {
    let result = await Post("api/goods/selected-lists", params);
    return result ?? null;
  }

  static async GoodUpdate(params) {
    let result = await Post("api/goods/update", params);
    return result ?? null;
  }
}

export const GoodFields = {
  GoodId: -1,
  GoodCode: null,
  GoodName: null,
  GoodShort: null,
  GoodUnitId: -1,
  GoodCateId: -1,
  GdSpcSubId: -1,
  GdSpecialtyId: -1,
  GdModId: -1,
};

export const SearchModality = (props) => {
  const [setSearchB, data, setData, userInfo, item] = props;
  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "gdmodid";
  const displayFieldName = "gdmodname";

  setSearchB({
    title: "Modality",
    size: "sm",
    show: true,
    fieldId: idFieldName,
    fieldName: "gdmodname",
    sql: {
      fields: ["gdmodid", "gdmodname"],
      tableName: "ba_goods_modality a ",
      defaultCriteria: " a.del_flag ='n' ",
      criteriaFields: ["a.gdmodshort"],
      criteriaText: "",
      orderBy: ["a.gdmodshort"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        ...DeepMergeObject(
          DotStringToObject(
            item.fieldName + "." + item.searchValueName,
            result[idFieldName]
          ),
          DotStringToObject(
            item.fieldName + "." + item.searchDisplayName,
            result[displayFieldName]
          )
        ),
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "gdmodname",
        text: "Modality",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};

export const SearchModalityPart = (props) => {
  const [setSearchB, data, setData, userInfo, item] = props;
  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "goodid";
  const displayFieldName = "goodname";

  setSearchB({
    title: "สินค้าหรือบริการ",
    size: "sm",
    show: true,
    fieldId: idFieldName,
    fieldName: "goodname",
    sql: {
      fields: ["goodid", "goodcode", "goodname"],
      tableName:
        "ba_goods a inner join ba_goods_cate b on a.GoodCateId = b.GoodCateId and b.Flag_Modality = 'y' ",
      defaultCriteria: " a.del_flag ='n' ",
      criteriaFields: ["a.goodcode", "a.goodname"],
      criteriaText: "",
      orderBy: ["a.goodname"],
      maxRows: 1000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        ...DeepMergeObject(
          DotStringToObject(
            item.fieldName + "." + item.searchValueName,
            result[idFieldName]
          ),
          DotStringToObject(
            item.fieldName + "." + item.searchDisplayName,
            result[displayFieldName]
          )
        ),
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "goodcode",
        text: "รหัส",
        sort: true,
        headerStyle: GetHeaderStyle("120px"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "goodname",
        text: "ชือส่วนตรวจ",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};
